import { render, staticRenderFns } from "./ParentFicheProfessionel.vue?vue&type=template&id=4a54de06&"
import script from "./ParentFicheProfessionel.vue?vue&type=script&lang=js&"
export * from "./ParentFicheProfessionel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports